import React from 'react';
import { Bot } from 'lucide-react';

export const TypingIndicator: React.FC = () => {
  return (
    <div className="flex items-start gap-3">
      <div className="w-8 h-8 bg-gray-200 dark:bg-slate-700 rounded-full flex items-center justify-center">
        <Bot className="w-5 h-5 text-gray-600 dark:text-gray-100" />
      </div>
      <div className="flex space-x-1 px-4 py-3 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-600 rounded-2xl rounded-tl-none w-20">
        <div className="w-2 h-2 bg-gray-400 dark:bg-slate-200 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
        <div className="w-2 h-2 bg-gray-400 dark:bg-slate-200 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
        <div className="w-2 h-2 bg-gray-400 dark:bg-slate-200 rounded-full animate-bounce" style={{ animationDelay: '600ms' }} />
      </div>
    </div>
  );
};